import type { DateFilter } from 'types/common';

const isValidDateFilter = (filter?: DateFilter): filter is Required<DateFilter> =>
  !!filter?.timeframe &&
  (filter.timeframe !== 'custom' ||
    !!(filter?.start && filter?.end && filter.start.length > 0 && filter.end.length > 0));

export default isValidDateFilter;
